import { render, staticRenderFns } from "./Presa.vue?vue&type=template&id=407858f0"
import script from "./Presa.vue?vue&type=script&lang=js"
export * from "./Presa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports